import { Container, Typography, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Header from "../components/common/Header";
import SubmitButton from "../components/common/SubmitButton";
import KycAnimation from "../components/Lottie/KycAnimation";
import KycCard from "../components/Cards/KycCard";
import configData from "../Config";
import { useNavigate, useLocation } from "react-router-dom";
import { apis } from "../services/apiService";
import LoadingDots from "../components/Lottie/LoadingDots";
import Backdrop from "../components/common/Backdrop";
import styles from "../Style/Modules/completeKyc.module.css";
import "../Style/Theme/index.css";

export default function CompleteKYC() {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  let location = useLocation();
  let handleSubmit = async (e) => {
    e.preventDefault();
    const data = { AppId: location.state.AppId };
    navigate("/pending-kyc", { state: data });
  };

  const getEnachUMRStatus = async () => {
    setLoading(true);
    try {
      let resp = await apis.getApi(
        `${configData.API_URL}Enach/VerifyEnachStatus?applicationId=${location.state.AppId}`
      );
      if (resp?.status === 200) {
        setLoading(false);
        let result = await resp?.json();
        if (result?.data?.result === "NotAvailable") {
          let data = {
            AppId: location.state.AppId,
          };
          navigate("/pending-enach", { state: data });
        } else if (!result?.data?.result) {
          let data = {
            AppId: location.state.AppId,
          };
          navigate("/pending-enach", { state: data });
        }
      }
    } catch (error) {
      setLoading(false);
      // const errorResult = JSON.parse(error?.message);
      let data = {
        AppId: location.state.AppId,
      };
      navigate("/pending-enach", { state: data });
    }
  };
  useEffect(() => {
    getEnachUMRStatus();
  }, []);
  return (
    <>
      <Container maxWidth={false} className="container_Th">
        <Header showBar={true} step={12} />
        <Box py={5} className={styles.completeKycBox}>
          <KycAnimation />
          <Box className={styles.completeKycBox1}>
            <Typography
              variant="h2"
              sx={{ mt: 1, mb: 2, fontWeight: "bold", color: "#0D1C6E" }}
            >
              {t("Complete your video KYC")}
            </Typography>
            <Typography variant="p" color="info" sx={{ textAlign: "center" }}>
              {t(
                "Your Loan Application is under process, this screen will be refreshed shortly."
              )}
            </Typography>
          </Box>
        </Box>
        <Box className={styles.completeKycBox2}>
          <KycCard
            icon="/assets/step1.svg"
            content="Enter your aadhaar number and verify using OTP"
          />{" "}
          <KycCard
            icon="/assets/step2.svg"
            content="Enter additional details required for KYC"
          />{" "}
          <KycCard
            icon="/assets/step3.svg"
            content="Video chat for identity verification"
          />
        </Box>
      </Container>
      <form onSubmit={handleSubmit}>
        <SubmitButton hasNote="No" />
      </form>
      {loading && (
        <Backdrop ax="center">
          <LoadingDots />
        </Backdrop>
      )}
    </>
  );
}
